exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscribe__price-text{font-size:16px;font-size:1rem}.subscribe__price-text--bold{font-weight:900}.subscribe__vat-text{margin-top:10px;margin-top:.625rem;margin-bottom:10px;margin-bottom:.625rem;font-size:12px;font-size:.75rem}.subscribe__paypal-container{height:120px;height:7.5rem}.subscribe__paypal-button{margin:30px 0;margin:1.875rem 0;opacity:.5}.v-input__icon{cursor:pointer}.left{margin-right:20px;margin-right:1.25rem}.right{margin-left:20px;margin-left:1.25rem}.spacer{height:30px;height:1.875rem}.sized-container{height:400px;height:25rem}.card{margin-bottom:30px;margin-bottom:1.875rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f6e1808","scoped":false,"hasInlineConfig":false}!./~/postcss-loader!./~/sass-loader/lib/loader.js!./app/components/subscribe/style.scss
// module id = 246
// module chunks = 0